module.exports = __webpack_public_path__ + "static/media/termostatica-01.84a833de.png";